import * as React from 'react'
import { BaseModalProps } from '@components/modals/types'
import { ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { SaveButton } from '@hyper/button'
import { useForm } from 'react-hook-form'
import { RootState, useAppDispatch, useAppSelector } from '@store/index'
import { useFormRequest } from '@components/hooks/use-api-request'
import { commonObjectPut } from '@store/actions/generic-actions'
import { useNotificationHook } from '@hyper/use-notification-hook'
import { Form } from '@hyper/forms/form'
import { PackageWholesaleProduct } from '@modules/package-wholesale/models'
import { CustomReactSelectOption } from '@components/custom-react-select'
import { packageWholesaleProductsStatusOptions } from '@modules/package-wholesale/products/list/filter'
import { updatePackageWholesaleProductsBulk } from '@store/slices/package-wholesale-slice'
import { FormSelect } from '@hyper/forms/form-select'

interface Props extends BaseModalProps {
  products: PackageWholesaleProduct[]
  clearSelectedRows: () => void
}

interface FormInputs {
  status: null | CustomReactSelectOption
}

export const PackageWholesaleProductStatusModal: React.FC<Props> = ({
  toggleIsVisible,
  products,
  clearSelectedRows,
}) => {
  const dispatch = useAppDispatch()
  const { addSuccessMessage } = useNotificationHook()
  const url = useAppSelector((state: RootState) => state.appState.appData.urls.package_wholesale.products)

  const methods = useForm<FormInputs>()

  const { isLoading, action: onSubmit } = useFormRequest(
    async (payload: FormInputs) => {
      dispatch(
        updatePackageWholesaleProductsBulk(
          await commonObjectPut<PackageWholesaleProduct[]>(url, {
            status: payload.status?.value,
            products: products.map(row => row.id),
          }),
        ),
      )
      addSuccessMessage()
      clearSelectedRows()
      toggleIsVisible()
    },

    methods.setError,
  )

  return (
    <Form methods={methods} onSubmit={onSubmit}>
      <ModalHeader>Zmień status produktów</ModalHeader>
      <ModalBody>
        <FormSelect options={packageWholesaleProductsStatusOptions} name="status" label="Status" />
      </ModalBody>
      <ModalFooter>
        <button type="button" onClick={toggleIsVisible} className="btn mr-1 btn-light">
          Anuluj
        </button>
        <SaveButton isSaving={isLoading} className="btn btn-green" />
      </ModalFooter>
    </Form>
  )
}
